import React from "react";
import transition from "../transition";

const Home = () => {
  return (
    <div className="container">
      <h1>Page Transitions In React</h1>
    </div>
  );
};

export default transition(Home);
